export default {
	invalidAccount: "Invalid user. Please sign up for an account to access Teaming.",
	unknownError: "An unknown error has occurred. Please contact Teaming for assistance.",
};
